import React from 'react';
import { Box, Grid, Stack } from '@mantine/core';
import {
  Column,
  ColumnType,
  MinMaxColumn,
} from 'components/MenuManagement/MenuItemActions/types/newDrawerTypes';

interface AddNewDrawerFieldRowProps {
  column: ColumnType;
  renderField: (column: Column) => React.ReactNode;
}

function isMinMaxColumn(col: ColumnType): col is MinMaxColumn {
  return col.dataIndex === 'minMax';
}

export default function AddNewDrawerFieldRow({ column, renderField }: AddNewDrawerFieldRowProps) {
  if (isMinMaxColumn(column)) {
    return (
      <Box key={`${column.dataIndex}-newRecord}`} mb="lg">
        <Grid gutter="xs">
          <Grid.Col span={6}>{renderField(column.minimum)}</Grid.Col>
          <Grid.Col span={6}>{renderField(column.maximum)}</Grid.Col>
        </Grid>
      </Box>
    );
  }
  return (
    <Box
      className={`add-item-drawer__row add-item-drawer__row__${
        column.dataIndex ?? column.inputType
      }`}
      key={`${column.dataIndex}-newRecord}`}
      mb={column.dataIndex === 'itemPhoto' ? 0 : undefined}
    >
      <Stack>{renderField(column)}</Stack>
    </Box>
  );
}
